import React from "react";
import { Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

const TableActionButtons = ({ item }) => {
    const { setDelData } = useAppContext();

    return (
        <div className="d-flex justify-content-end">
            <Link
                to={url_reverse("admin:landing_ct:edit_landing", {
                    item_id: item.id,
                })}
                className="btn btn-sm btn-outline-primary ml-1"
            >
                <Awesome type="pencil" />
            </Link>
            <Button
                variant="outline-danger"
                size="sm"
                className="ml-1"
                onClick={() =>
                    setDelData({
                        url: url_reverse("api:landing_ct:landing_edit_delete", {
                            pk: item.id,
                        }),
                    })
                }
            >
                <Awesome type="trash-o" />
            </Button>
        </div>
    );
};

export default function LandingCTList() {
    const apiUrl = url_reverse("api:landing_ct:landings");
    const { apiData } = useAppApi(apiUrl);
    const { t } = useTranslation();

    const header = (
        <>
            <Link to={url_reverse("admin:pockets:list")}>{t("Карманы")}</Link>
            <span> – </span>
            {t("Лендинги")}
        </>
    );

    const headerTools = (
        <>
            <Link to={url_reverse("admin:landing_ct:add_landing")} className="btn btn-sm btn-dark">
                <Awesome type="plus-circle" /> {t("Добавить")}
            </Link>
        </>
    );

    if (!apiData) return null;

    return (
        <DefaultLayout>
            <ListingCard header={header} headerTools={headerTools}>
                <Table responsive hover className="dmg-table">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>{t("Название")}</th>
                            <th style={{ width: "40%" }}>{"URL"}</th>
                            <th style={{ width: "10%" }}>{t("Активен")}</th>
                            <th style={{ width: "10%" }}>{t("Мобильная версия")}</th>
                            <th style={{ width: "10%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiData.object_list?.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <Link to={url_reverse("admin:landing_ct:landing_items", { slug: item.slug })}>
                                        {item.name}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={item.url} target="_blank">
                                        {item.url}
                                    </Link>
                                </td>
                                <td>
                                    {item.is_active ? (
                                        <Awesome type="check" color="green" />
                                    ) : (
                                        <Awesome type="times" color="red" />
                                    )}
                                </td>
                                <td>
                                    {item.mobile_version ? (
                                        <Awesome type="check" color="green" />
                                    ) : (
                                        <Awesome type="times" color="red" />
                                    )}
                                </td>
                                <td>
                                    <TableActionButtons item={item} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ListingCard>
        </DefaultLayout>
    );
}
